import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { AgendaItem, FileItem, ScheduleItem } from '@/types';

interface ModalState {
    absentUsers: string[];
    agenda: AgendaItem[];
    files: FileItem[];
    scheduleItems: ScheduleItem[];
    editScheduleItem: ScheduleItem | null;
    scheduleDate: string;
    changeRequests: { categoryName: string; userName: string; count: number }[];
    modalContextDate: string;
}

const initialState: ModalState = {
    absentUsers: [],
    agenda: [],
    files: [],
    scheduleItems: [],
    editScheduleItem: null,
    scheduleDate: '',
    changeRequests: [],
    modalContextDate: '',
};

const modalSlice = createSlice({
    name: 'modal',
    initialState,
    reducers: {
        setAbsentUsers: (state, action: PayloadAction<string[]>) => {
            state.absentUsers = action.payload;
        },
        setAgenda: (state, action: PayloadAction<AgendaItem[]>) => {
            state.agenda = action.payload;
        },
        setFiles: (state, action: PayloadAction<FileItem[]>) => {
            state.files = action.payload;
        },
        setScheduleItems: (state, action: PayloadAction<ScheduleItem[]>) => {
            state.scheduleItems = action.payload;
        },
        setEditScheduleItem: (state, action: PayloadAction<ScheduleItem | null>) => {
            state.editScheduleItem = action.payload;
        },
        setScheduleDate: (state, action: PayloadAction<string>) => {
            state.scheduleDate = action.payload;
        },
        setChangeRequests: (
            state,
            action: PayloadAction<{ categoryName: string; userName: string; count: number }[]>
        ) => {
            state.changeRequests = action.payload;
        },
        setModalContextDate: (state, action: PayloadAction<string>) => {
            state.modalContextDate = action.payload;
        },
        clearModalData: (state) => {
            state.absentUsers = [];
            state.agenda = [];
            state.files = [];
            state.scheduleItems = [];
            state.editScheduleItem = null;
            state.scheduleDate = '';
            state.changeRequests = [];
            state.modalContextDate = '';
        },
    },
});

export const {
    setAbsentUsers,
    setAgenda,
    setFiles,
    setScheduleItems,
    setEditScheduleItem,
    setScheduleDate,
    setChangeRequests,
    setModalContextDate,
    clearModalData,
} = modalSlice.actions;
export default modalSlice.reducer;
